import React from 'react'
import { Link } from 'react-router-dom'
import {FormattedMessage, useIntl} from "react-intl";
import messages from "./messages";

const Notifications = ({ notifications, onNotificationChange, user, onUserChange }) => (
  <React.Fragment>
    <div className="mt-10 divide-y divide-gray-200">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          <FormattedMessage {...messages.notifications}/>
        </h3>
        <p className="max-w-2xl text-sm text-gray-500">
          <FormattedMessage {...messages.manageNotifications}/>
        </p>
      </div>
      <div className="mt-6">
        { notifications.map(({ id, name, description, enabled }) => (
          <dl key={id} className="divide-y divide-gray-200">
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt className="text-sm font-medium text-gray-500">
                { name }
              </dt>
              <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <span className="grow">{ description }</span>
                <button type="button" onClick={() => onNotificationChange(id, !enabled)} className={`${enabled ? 'bg-primary': 'bg-gray-200'} relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-auto`} aria-pressed="false" aria-labelledby="auto-update-option-label">
                  <span className="sr-only"><FormattedMessage {...messages.useSetting}/></span>
                  <span aria-hidden="true" className={`${enabled ? 'translate-x-5' :'translate-x-0'} inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`}></span>
                </button>
              </dd>
            </div>
          </dl>
        )) }
      </div>
    </div>
    <div className="mt-10 divide-y divide-gray-200">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          <FormattedMessage {...messages.manage}/>
        </h3>
        <p className="max-w-2xl text-sm text-gray-500">
          <FormattedMessage {...messages.manageHowNotified}/>
        </p>
      </div>
      <div className="mt-6">
        <dl className="divide-y divide-gray-200">
          <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:pt-5">
            <dt className="text-sm font-medium text-gray-500" id="timezone-option-label">
              <FormattedMessage {...messages.email}/>
            </dt>
            <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              <span className="grow"><FormattedMessage {...messages.email}/></span>
              <button type="button" onClick={() => onUserChange({ ...user, notify_email: !user.notify_email })} className={`${user.notify_email ? 'bg-primary': 'bg-gray-200'} relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-auto`} aria-pressed="false" aria-labelledby="auto-update-option-label">
                <span className="sr-only"><FormattedMessage {...messages.sentToEmail}/></span>
                <span aria-hidden="true" className={`${user.notify_email ? 'translate-x-5' :'translate-x-0'} inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`}></span>
              </button>
            </dd>
          </div>
          <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-b sm:border-gray-200">
            <dt className="text-sm font-medium text-gray-500" id="auto-update-option-label">
              <FormattedMessage {...messages.pushNotifications}/>
            </dt>
            <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              <span className="grow"><FormattedMessage {...messages.ifEnabledInBrowser}/></span>
              <button type="button" onClick={() => onUserChange({ ...user, notify_push: !user.notify_push })} className={`${user.notify_push ? 'bg-primary': 'bg-gray-200'} relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-auto`} aria-pressed="false" aria-labelledby="auto-update-option-label">
                <span className="sr-only"><FormattedMessage {...messages.useSetting}/></span>
                <span aria-hidden="true" className={`${user.notify_push ? 'translate-x-5' :'translate-x-0'} inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`}></span>
              </button>
            </dd>
          </div>
          <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-b sm:border-gray-200">
            <dt className="text-sm font-medium text-gray-500" id="auto-update-option-label">
              <FormattedMessage {...messages.smsNotifications}/>
            </dt>
            <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              <span className="grow"><FormattedMessage {...messages.smsNotifications}/></span>
              <button type="button" onClick={() => onUserChange({ ...user, notify_sms: !user.notify_sms })} className={`${user.notify_sms ? 'bg-primary': 'bg-gray-200'} relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:ml-auto`} aria-pressed="false" aria-labelledby="auto-update-option-label">
                <span className="sr-only"><FormattedMessage {...messages.useSetting}/></span>
                <span aria-hidden="true" className={`${user.notify_sms ? 'translate-x-5' :'translate-x-0'} inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`}></span>
              </button>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </React.Fragment>
)

export default Notifications
